import { getPageDetails } from '../../utils';
import { sendToMixpanel } from '../../mixpanel';

const trackSubmitIntent = (intent: string): void => {
  const { pageType } = getPageDetails();

  sendToMixpanel('Enquiry Form Intent Confirmed', {
    enquiryLocation: pageType,
    enquiryFormType: 'inline',
    enquiryCTA: `${pageType} Inline`,
    enquiryIntentSelections: [intent],
  });
};

export default trackSubmitIntent;
